import { render, staticRenderFns } from "./c_Creator_EditQuests_Item_permissions.vue?vue&type=template&id=c16ffd50&scoped=true&"
import script from "./c_Creator_EditQuests_Item_permissions.vue?vue&type=script&lang=js&"
export * from "./c_Creator_EditQuests_Item_permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16ffd50",
  null
  
)

export default component.exports